import Axios from "axios";
import variable from "json/variable.json";

Axios.defaults.baseURL = variable[process.env.NODE_ENV].backend_url;
Axios.defaults.headers.common.Accept = "application/json";

Axios.interceptors.request.use(async (config) => {
  let token = localStorage.getItem("token");
  const refToken = localStorage.getItem("refToken");
  if (!!token) {
    config.headers.Authorization = `Bearer ${token}`;
    try {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");

      const decodeToken = JSON.parse(
        decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        )
      );

      // token expired
      // TODO : 현재는 refresh token을 매번 가지고 오고 있는데, 한번만 가져오도록 수정할필요있음
      if (decodeToken.exp * 1000 <= new Date().getTime() && !!refToken) {
        if (!!refToken) {
          await refreshToken({ refresh: refToken }).then((e) => {
            token = e.access;

            if (!token) {
              localStorage.clear();
              window.location.pathname = "/sign-in";
            }

            localStorage.setItem("token", e.access);
            config.headers.Authorization = `Bearer ${token}`;
          });
        }
      }
    } catch (e) {
      localStorage.clear();
      window.location.pathname = "/sign-in";
    }
  }

  return config;
});

Axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response.status / 5 < 100) {
      return Promise.reject(error.response.data);
    } else {
      console.log("서버이슈");
    }
  }
);

export const refreshToken = async (data: { refresh: string }) =>
  await (
    await fetch(
      `${variable[process.env.NODE_ENV].backend_url}/accounts/token/refresh/`,
      {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          Authorization: `Bearer ${localStorage.getItem("refToken")}`,
          "Content-Type": "application/json",
        },
      }
    )
  ).json();

export const _post = async (url: string, data?: object) => {
  let curData = data ?? {};
  if (!!curData) {
    curData = Object.keys(curData).reduce((accm, curr) => {
      // @ts-ignore
      if (!!data[curr]) {
        // @ts-ignore
        accm[curr] = data[curr];
      }
      return accm;
    }, {});
  }
  const stringifyCurData = JSON.stringify(curData);
  const returnVal = (await Axios.post(url, JSON.parse(stringifyCurData))).data;
  return typeof returnVal === "string" || typeof returnVal === "object"
    ? returnVal
    : JSON.parse(returnVal);
};

export const _get = async (url: string, data?: { [key: string]: any }) => {
  let param = "";
  if (!!data) {
    param = Object.keys(data)
      .reduce(
        (acc, cur) => (!!data[cur] ? `${acc}${cur}=${data[cur]}&` : acc),
        "?"
      )
      .slice(0, -1);
  }
  return (await Axios.get(`${url}${param}`)).data;
};

export const _put = async (url: string, data?: { [key: string]: any }) => {
  return (await Axios.put(url, data)).data;
};

export const _delete = async (url: string) => {
  return await Axios.delete(url);
};
